import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useSiteMetadata } from "../hooks/defaults/Use-SiteMetadata";
function Seo({ description, title, phone, children }) {
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						phoneNum
						address {
							streetAddress
							addressLocality
							addressRegion
							postalCode
							addressCountry
						}
					}
				}
			}
		`
	);
	const SiteData = useSiteMetadata();

	const metaDescription = description || SiteData.description;
	const defaultTitle = SiteData.title;
	const phoneNum = phone ? phone : SiteData.phoneNum;

	return (
		<>
			<meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
			<title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
			<meta name="description" content={metaDescription} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={metaDescription} />
			<meta property="og:type" content="website" />

			<script type="application/ld+json">
				{JSON.stringify({
					"@context": "http://schema.org",
					"@type": SiteData?.googleData?.type,
					"@id": SiteData?.googleData?.id,
					mainEntityOfPage: SiteData?.googleData?.mainEntityOfPage,
					additionalType: SiteData?.googleData?.mainEntityOfPage,
					address: {
						"@type": "PostalAddress",
						addressLocality: SiteData.address?.addressLocality,
						addressRegion: SiteData.address?.addressRegion,
						postalCode: SiteData.address?.postalCode,
						streetAddress: SiteData?.address?.streetAddress,
						addressCountry: SiteData?.address?.addressCountry,
					},
					name: SiteData?.tradingName,
					alternatename: defaultTitle,
					description: SiteData?.googleData?.description
						? SiteData?.googleData?.description
						: SiteData?.description,
					email: `contact@${String(SiteData?.siteUrl).replace("https://", "")}`,
					priceRange: "£££-£££££",
					openingHours: SiteData?.googleData?.openingHours,
					telephone: phoneNum,
					URL: SiteData?.siteUrl,
					sameAs: SiteData?.googleData?.sameAs,
					logo: SiteData?.googleData?.logo
						? SiteData?.googleData?.logo
						: `${SiteData?.siteUrl}/favicon-32x32.png`,
					image: `${SiteData?.siteUrl}/favicons/icon-384x384.png`,
					hasMap: SiteData?.googleData?.hasMap,
					geo: {
						"@type": "GeoCoordinates",
						latitude: SiteData?.address?.latitude,
						longitude: SiteData?.address?.longitude,
					},
				})}
			</script>
			{children}
		</>
	);
}

export default Seo;
